import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-gray-900 text-white sticky top-0 z-50" data-id="element-139">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-140">
        <div className="flex items-center" data-id="element-141">
          <h1 className="text-xl md:text-2xl font-bold" data-id="element-142">
            <span className="text-white" data-id="element-143">New Louzan</span>
            <span className="text-amber-400" data-id="element-144"> Building Maintenance</span>
          </h1>
        </div>
        {/* Mobile menu button */}
        <button className="md:hidden text-white focus:outline-none" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-145">
          {isMenuOpen ? <X size={24} data-id="element-146" /> : <Menu size={24} data-id="element-147" />}
        </button>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-148">
          <a href="#home" className="text-white hover:text-amber-400 transition-colors" data-id="element-149">
            Home
          </a>
          <a href="#about" className="text-white hover:text-amber-400 transition-colors" data-id="element-150">
            About
          </a>
          <a href="#services" className="text-white hover:text-amber-400 transition-colors" data-id="element-151">
            Services
          </a>
          <a href="#why-us" className="text-white hover:text-amber-400 transition-colors" data-id="element-152">
            Why Us
          </a>
          <a href="#contact" className="text-white hover:text-amber-400 transition-colors" data-id="element-153">
            Contact
          </a>
          <a href="tel:+971507583460" className="flex items-center bg-amber-500 hover:bg-amber-600 px-4 py-2 rounded-md transition-colors" data-id="element-154">
            <Phone size={18} className="mr-2" data-id="element-155" />
            Call Now
          </a>
        </nav>
        {/* Mobile Navigation */}
        {isMenuOpen && <div className="absolute top-full left-0 right-0 bg-gray-900 p-4 md:hidden" data-id="element-156">
            <nav className="flex flex-col space-y-4" data-id="element-157">
              <a href="#home" className="text-white hover:text-amber-400 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-158">
                Home
              </a>
              <a href="#about" className="text-white hover:text-amber-400 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-159">
                About
              </a>
              <a href="#services" className="text-white hover:text-amber-400 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-160">
                Services
              </a>
              <a href="#why-us" className="text-white hover:text-amber-400 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-161">
                Why Us
              </a>
              <a href="#contact" className="text-white hover:text-amber-400 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-162">
                Contact
              </a>
              <a href="tel:+971507583460" className="flex items-center bg-amber-500 hover:bg-amber-600 px-4 py-2 rounded-md transition-colors" data-id="element-163">
                <Phone size={18} className="mr-2" data-id="element-164" />
                Call Now
              </a>
            </nav>
          </div>}
      </div>
    </header>;
}